import { ICArea } from "./icarea";

export class ICAreaRelation {
  Automatic: boolean;
  Children: ICArea;
  Father: ICArea;
  Id: number;
  IdGuid: string;
  Level: number;

  constructor(data?: Partial<ICAreaRelation>) {
    Object.assign(this, data);
  }
}
